























































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import UnitModel from '@/_models/UnitModel'
import NotFound from '@/components/common/NotFound.vue'
import { ApiKeyModel } from '@/_models/UnitModel'
import * as DownloadCsv from 'vue-json-csv'

@Component({
  components: { DownloadCsv, NotFound },
  computed: {
    ...mapGetters('units', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('units', {
      canDelete: 'canDelete',
    }),
  },
})
export default class UnitList extends Vue {
  // data
  private isPaginated: boolean = true
  private isPaginationSimple: boolean = false
  private paginationPosition: string = 'bottom'
  private defaultSortDirection: string = 'asc'
  private sortIcon: string = 'arrow-up'
  private sortIconSize: string = 'is-small'
  private currentPage: number = 1
  private perPage: number = 10
  private numofPage: number = 1
  private selected: UnitModel = new UnitModel()
  private apiKeys: any = []

  private isFormModalActive: boolean = false
  private searchQuery: string = ''
  private isNew: boolean = false
  private canEdit!: boolean
  private canDelete!: boolean
  private selectedFilter: string = 'name'
  private uploadFile: any = null

  private filedNameLUT: any = {
    _id: 'UUID',
    name: 'label.unit_name',
    customer_name: 'label.customer_name',
    address: 'label.address',
    token: 'label.token',
    domains: 'label.domains',
  }

  // Export csv setting
  private csvFields: any = [
    '_id',
    'name',
    'customer_name',
    'address',
    'token',
    'domains',
  ]

  // computed
  get units(): UnitModel[] {
    const units = this.$store.state.units.all.items
    this.numofPage = Math.ceil(units.length / this.perPage)

    return units.map((item: UnitModel) => {
      if (item.is_active === undefined) {
        item.is_active = true
      }
      return item
    })
  }

  get apiKeyAccessRightOptions(): any {
    return [
      {
        code: 1,
        label: 'option.api_key_access_right.owner',
      },
      {
        code: 2,
        label: 'option.api_key_access_right.admin',
      },
      {
        code: 3,
        label: 'option.api_key_access_right.viewer',
      },
    ]
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isLoading(): boolean {
    return this.$store.state.units.loading
  }

  get filteredData(): UnitModel[] {
    const targetField: string = this.selectedFilter
    if (!this.units) {
      return []
    }

    return this.units.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  public doApplyChangeStatus(unit: UnitModel) {
    this.$store.dispatch('units/updateOne', unit).then(resp => {
      this.$buefy.toast.open(this.$t('messages.update_success') as string)
    })
  }

  @Watch('isFormModalActive')
  private watchFormModalActive(): void {
    this.uploadFile = null
  }

  // Handle methods
  private handleAddDomain(index: number): void {
    this.selected.domains.splice(index + 1, 0, '')
  }

  private handleDeleteDomain(index: number): void {
    this.selected.domains.splice(index, 1)
  }

  private handleAddApiKey(index: number): void {
    this.apiKeys.splice(index + 1, 0, new ApiKeyModel())
  }

  private handleDeleteApiKey(index: number): void {
    this.apiKeys.splice(index, 1)
  }

  private handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
    this.apiKeys = this.selected.api_keys
    this.selected.domains = Object.assign([], data.domains)

    this.isNew = false
  }

  private handleOpenModalAdd(data): void {
    this.isFormModalActive = true
    this.selected = new UnitModel()
    this.apiKeys = this.selected.api_keys
    this.isNew = true
  }

  private async handleApplyChange(): Promise<void> {
    if (this.uploadFile) {
      this.$store.dispatch('units/uploadFile', this.uploadFile).then((resp) => {
        this.selected.logo = resp.filename
        this.doApplyChange()
      })
    } else {
      this.doApplyChange()
    }
  }

  private handleConfirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.$store.dispatch('units/hasRefs', this.selected).then((result) => {
          if (result.has_reference) {
            this.confirmForceDelete(data)
          } else {
            this.processDelete(data)
          }
        })
      },
    })
  }

  // methods
  private isSupperUnit(item: UnitModel): boolean {
    return item.db_name === 'socan_api'
  }

  private convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  private async doApplyChange(): Promise<void> {
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return false
      }

      this.selected.api_keys = this.apiKeys
      if (this.isNew) {
        // add item
        this.$store.dispatch('units/addOne', this.selected).then((resp) => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store.dispatch('units/updateOne', this.selected).then((resp) => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.update_success') as string)
        })
      }
    })
  }

  private confirmForceDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t(
        'messages.has_refs_data_are_you_sure_want_to_delete'
      ) as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      },
    })
  }

  private processDelete(data): void {
    this.selected = data
    this.$store.dispatch('units/deleteOne', this.selected).then(() => {
      this.selected = new UnitModel()
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  // After page created
  private created() {
    this.$store.dispatch('units/getAll')
  }
}
